import {inject, Injectable} from '@angular/core';
import {CdRai} from '../../interfaces/care/cd-rai/cd-rai';
import {SecureTable} from '../secure.table';
import {DefaultAdapter} from '../../adapters/default.adapter';
import {CdRaiFactory} from '../../factories/care/cd-rai/cd-rai-factory';
import {db} from '../db.service';
import {CdMdsAnswersTable} from './cd-mds-answers.table';

@Injectable({
  providedIn: 'root'
})
export class CdRaisTable extends SecureTable<CdRai> {

  private readonly _cdMdsAnswersTable: CdMdsAnswersTable;

  constructor() {
    super(db.cdRais);
    this._tableSyncSettings = {
      error: false,
      syncMode: 'default',
      dependencies: [],
      adapter: new DefaultAdapter<CdRai>({
        api: ['care', 'c-rais'],
        fromObject: CdRaiFactory.fromObject,
        toRemote: CdRaiFactory.toRemote
      })
    };
    this._cdMdsAnswersTable = inject(CdMdsAnswersTable);
  }

  /**
   *
   * @param customerId
   */
  public async getByCustomerId(customerId: number): Promise<CdRai[]> {
    const cdRais = await this.table.where('customerId').equals(customerId).reverse().sortBy('date');
    const cdMdsAnswers = await this._cdMdsAnswersTable.getByCdRaiUuids(cdRais.map(_cdRai => _cdRai.uuid));

    return cdRais.map(_cdRai => {
      _cdRai.cdMdsAnswers = cdMdsAnswers.filter(_cdMdsAnswer => _cdMdsAnswer.cdRaiUuid === _cdRai.uuid);
      return _cdRai;
    });
  }

  /**
   *
   */
  public override async getSynced(): Promise<CdRai[]> {
    const cdRais = await super.getSynced();
    const syncedCdRais: CdRai[] = [];
    for(const cdRai of cdRais) {
      if(await this._cdMdsAnswersTable.isSyncedByCdRaiUuids([cdRai.uuid])) {
        syncedCdRais.push(cdRai);
      }
    }
    return syncedCdRais;
  }

  /**
   *
   */
  public override async removeMany(cdRaisUuids: string[], force: boolean = false): Promise<void> {
    const cdMdsAnswers = await this._cdMdsAnswersTable.getByCdRaiUuids(cdRaisUuids);
    await this._cdMdsAnswersTable.removeMany(cdMdsAnswers.map(_cdMdsAnswer => _cdMdsAnswer.uuid), force);
    await super.removeMany(cdRaisUuids, force);
  }

  /**
   *
   * @param cdRaiUuid
   * @param force
   */
  public override async remove(cdRaiUuid: string, force: boolean = false): Promise<void> {
    const cdMdsAnswers = await this._cdMdsAnswersTable.getByCdRaiUuid(cdRaiUuid);
    await this._cdMdsAnswersTable.removeMany(cdMdsAnswers.map(_cdMdsAnswer => _cdMdsAnswer.uuid), force);
    await super.remove(cdRaiUuid, force);
  }

}
